import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import {
  Box,
  Grid,
  Button,
  Typography,
  CircularProgress,
  // Divider,
  Tab,
} from '@mui/material';
import {
  Group,
  Image,
  Layer,
  Rect,
  Stage,
  Text,
  Transformer,
} from 'react-konva';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import randomstring from 'randomstring';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import { ReactComponent as DeleteOutlineIcon } from '../../../../assets/common-assets/trash.svg';
import checkCircle from '../../../../assets/common-assets/check-circle-white.svg';
import Edit from '../../../../assets/common-assets/edit.svg';
import {
  getAnnotationData,
  getCheckedDataFields,
  getNewBoxAnnotationData,
  validateDoc,
} from '../../../../services/annotation';
import { ANNOTATION, INVOICE } from '../../../../constants/staticContent';
import { Root, classes } from './utils';
import DocumentRecord from './DocumentRecord';
import Toast from '../../utils/Toast';
import {
  getAllVersion,
  getVersionAnnotationData,
  specificVersionValidate,
} from '../../../../services/versionApi';
import Input from './Input';
import AnnotationSubNav from './AnnotationSubNav';
import ConfirmDocument from './ConfirmDocument';
import { lightPalette } from '../../../../theme';
import { ANNOTATION_TOAST } from '../../../../constants/toastConstant';
import fetchLocation from '../../../../services/userLocation';
import 'pdfjs-dist/build/pdf.worker.min.mjs';
import { markNotificationAsRead } from '../../../../services/tabSection';
import { completeNotification } from '../../../../store/socketSlice';
import AgGrid from '../../common-components/common-ag-grid/AgGrid';
import {
  deleteDocument,
  getGridFilterSortStatus,
} from '../../../../services/allInvoiceApi';
import transactionColumnDef from './transactionColumnDef';
import paymentColumnDef from './paymentColumnDef';
import ConfirmDialog from '../../utils/ConfirmDialog';
import ResizeGrid from '../../common-components/resizeGrid/ResizeGrid';
import { getCheckboxField } from '../../../../services/accountSetting';

const TabData = [
  {
    label: 'Bank Statement Details',
    index: '1',
  },
  {
    label: 'Transactions',
    index: '2',
  },
];
const CreditCardTabData = [
  {
    label: 'Credit Card Details',
    index: '1',
  },
  {
    label: 'Transactions',
    index: '2',
  },
];
const ReceiptTabData = [
  {
    label: 'Receipt Details',
    index: '1',
  },
  {
    label: 'Payment',
    index: '2',
  },
];
const SalesTabData = [
  {
    label: 'Sales Details',
    index: '1',
  },
  {
    label: 'Payment',
    index: '2',
  },
];
const InvoiceTabData = [
  {
    label: 'Invoice Details',
    index: '1',
  },
  {
    label: 'Payment',
    index: '2',
  },
];

const DocumentAnnotation = () => {
  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const queryParams = new URLSearchParams(location.search);
  const isEditing =
    queryParams.get('editing') === 'true' ? queryParams.get('editing') : null;

  const [id, setId] = useState();
  const [versionId, setVersionId] = useState('');
  const [invoiceImg, setInvoiceImg] = useState([]);
  const [data, setData] = useState([]);
  const [customerData, setCustomerData] = useState([]);
  const [invoiceReceiptData, setInvoiceReceiptData] = useState([]);
  const [paymentData, setPaymentData] = useState([]);
  const [paymentMethodData, setPaymentMethodData] = useState([]);
  const [bankDetails, setBankDetails] = useState([]);
  const [supplierData, setSupplierData] = useState([]);
  const [productData, setProductData] = useState([]);
  const [productDataGrid, setProductDataGrid] = useState([]);
  const [productCount, setProductCount] = useState();
  const [products, setProducts] = useState([]);
  const productRef = useRef([]);
  productRef.current = products;
  const [cardHolder, setCardHolder] = useState([]);
  const [statement, setStatement] = useState([]);
  const [Transactions, setTransactions] = useState([]);
  const transactionsRef = useRef([]);
  transactionsRef.current = Transactions;
  const [transactionData, setTransactionData] = useState([]);
  const [transactionDataGrid, setTransactionDataGrid] = useState([]);
  const [transactionCount, setTransactionCount] = useState();
  const [GSTInfo, setGSTInfo] = useState([]);
  const [cardInfo, setCardInfo] = useState([]);
  const [accountHolderDetails, setAccountHolderDetails] = useState([]);
  const [statementDetails, setStatementDetails] = useState([]);
  const [summary, setSummary] = useState([]);
  const [bankCharges, setBankCharges] = useState([]);
  const [checkedDataFields, setCheckedDataFields] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [popUpLoader, setPopUpLoader] = useState(true);
  const [isUpdatedData, setIsUpdatedData] = useState(false);
  const [mappedResult, setMappedResult] = useState([]);
  const [changedData, setChangedData] = useState([]);
  const [invoiceVersions, setInvoiceVersions] = useState([]);
  const [exportDocumentOpen, setExportDocumentOpen] = useState(false);
  const [isVersionAdded, setIsVersionAdded] = useState(false);
  const [latestVersion, setLatestVersion] = useState('');
  const [gridSettingData, setGridSettingData] = useState({});
  const [newAnnotation, setNewAnnotation] = useState([]);
  const [imageUrl, setImageUrl] = useState([]);
  const [initialDataColor] = useState('rgba(255,165,0,1)');
  const [newAnnotationColor] = useState('blue');
  const [validateColor] = useState('rgba(34,139,34, 1)');
  const [hoverRectFillColor, setHoverRectFillColor] = useState('');
  const [isDialogOpen, setDialogOpen] = useState(false);
  const [selectedBox, setSelectedBox] = useState(null);
  const [transformBox, setTransformBox] = useState(null);
  const [draggedBox, setDraggedBox] = useState(null);
  const [hoverId, setHoverId] = useState('');
  const [tooltipId, setTooltipId] = useState('');
  const [isDragging, setIsDragging] = useState(false);
  const shapeRef = useRef([]);
  const transformRef = useRef([]);
  const stageRef = useRef(null);
  const textRef = useRef(null);
  const [locationData, setLocationData] = useState(null);
  const [saveAndExitOpen, setSaveAndExitOpen] = useState(false);
  const [exportToXmlOpen, setExportToXmlOpen] = useState(false);
  const [exportToJsonOpen, setExportToJsonOpen] = useState(false);
  const [saveOpen, setSaveOpen] = useState(false);
  const [imageSize, setImageSize] = useState({
    width: 0,
    height: 0,
  });
  const [versionChange, setVersionChange] = useState(false);
  const [selectedVersionId, setSelectedVersionId] = useState('');
  const [currentPageImage, setCurrentPageImage] = useState();
  const [currentPageNumber, setCurrentPageNumber] = useState();
  const [currentPageIndex, setCurrentPageIndex] = useState(0);
  const [tabValue, setTabValue] = React.useState('1');
  const [isEdited, setIsEdited] = useState(false);
  const [tabSectionItem, setTabSectionItem] = useState(TabData);
  const [imageCount, setImageCount] = useState(1);
  const [isConfirmationDialogOpen, setIsConfirmationDialogOpen] =
    useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 1100);
  const [dimensions, setDimensions] = useState([70, 30]);
  const [dataProductAndTransaction, setDataProductAndTransaction] = useState(
    {},
  );
  const carouselRef = useRef(null);
  const dataRef = useRef([]);
  dataRef.current = data;
  const gridKeysValue =
    location?.pathname.includes('bank-statement') ||
    location?.pathname.includes('creditcardstatement');
  useEffect(() => {
    const fetchLocationService = async () => {
      try {
        const response = await fetchLocation();
        setLocationData(response);
      } catch (error) {
        return error;
      }
    };

    fetchLocationService();
  }, []);
  const parentRef = useRef();
  const [originalImageSize, setOriginalImageSize] = useState({
    width: '',
    height: '',
  });
  const [openedData, setOpenedData] = useState({
    label: '',
    value: '',
  });
  useEffect(() => {
    setId(params?.id);
  }, [params?.id]);
  const getInvoiceVersion = async () => {
    try {
      const response = await getAllVersion({}, '', {}, {}, params?.id);
      if (response) {
        setInvoiceVersions(
          response?.map((item) => ({
            id: item.id,
            version: item.version,
          })),
        );
      } else {
        setInvoiceVersions([]);
      }
    } catch (error) {
      return error;
    }
  };
  const getAllTransaction = async () => {
    const productItems =
      location?.pathname.includes('invoice') ||
      location?.pathname.includes('sale') ||
      location?.pathname.includes('receipt')
        ? productRef.current
        : transactionsRef.current;
    if (productItems.length > 0) {
      const mapData = [];
      productItems.forEach((elem) => {
        const result = elem.reduce((acc, item) => {
          // Add each label-value pair to the accumulator
          acc[item.label] = {
            id: item.id,
            product: item.product,
            value: item.value,
          };
          return acc;
        }, {});
        mapData.push(result);
      });
      console.log('mapData', mapData);
      return mapData;
    }
  };
  useEffect(() => {
    getInvoiceVersion();
  }, [isLoading, isVersionAdded]);

  useEffect(() => {
    const parentElement = parentRef.current;
    const updateSize = () => {
      if (parentElement) {
        setOriginalImageSize({
          width: parentElement.clientWidth - 10,
          height: parentElement.clientHeight * 2,
        });
      }
    };

    const handleResize = () => {
      // Call updateSize whenever the window is resized
      updateSize();
    };

    if (parentElement) {
      // Call updateSize initially
      updateSize();

      // Add event listener for window resize
      window.addEventListener('resize', handleResize);
    }

    // Cleanup: Remove event listener when component unmounts
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [isLoading, parentRef.current, dimensions]);

  const getDataFields = async () => {
    let fieldType;

    switch (true) {
      case location?.pathname.includes('invoice'):
        fieldType = 'invoice_field';
        break;
      case location?.pathname.includes('sale'):
        fieldType = 'sales_field';
        break;
      case location?.pathname.includes('receipt'):
        fieldType = 'receipt_field';
        break;
      case location?.pathname.includes('creditcardstatement'):
        fieldType = 'cc_field';
        break;
      case location?.pathname.includes('bank-statement'):
        fieldType = 'bs_field';
        break;
      default:
        fieldType = 'default_field';
    }
    const response = await getCheckedDataFields(fieldType);
    setCheckedDataFields(response);
    const gridData = await getCheckboxField(fieldType);
    setDataProductAndTransaction(gridData);
  };

  useEffect(() => {
    getDataFields();
  }, []);

  const getDocAnnotation = async (idFromData) => {
    const response = await getAnnotationData(idFromData);
    if (response) {
      const mapData = gridKeysValue
        ? response?.mapped_result
        : response?.mapped_result[0];
      const mapMergedData = gridKeysValue
        ? mapData
        : Object.keys(mapData).reduce(
            (acc, key) => [...acc, ...mapData[key]],
            [],
          );
      setMappedResult(mapMergedData);
      const annotationData =
        response?.annotation_data && response?.annotation_data.length > 0
          ? response?.annotation_data
          : response?.mapped_result;
      if (annotationData) {
        const mergedData = gridKeysValue
          ? annotationData
          : Object.keys(annotationData[0]).reduce(
              (acc, key) => [...acc, ...annotationData[0][key]],
              [],
            );
        const productAndTransactionCount = [];
        mergedData.forEach((a) => {
          if (a?.product) {
            if (productAndTransactionCount.length === 0) {
              productAndTransactionCount.push(a?.product);
            } else if (!productAndTransactionCount.includes(a?.product)) {
              productAndTransactionCount.push(a?.product);
            }
          }
        });
        setProductCount(productAndTransactionCount.length);
        setTransactionCount(productAndTransactionCount.length);
        setData(annotationData);
        setIsLoading(false);
      }

      const url = response?.url;
      setInvoiceImg(url);
      setImageCount(url.length);
      const imageObjects = Array.from(
        { length: url.length },
        () => new window.Image(),
      );
      setImageUrl(imageObjects);
      if (response?.document?.status === 'unread') {
        const readNotification = await markNotificationAsRead(
          response?.document?.id,
        );
        if (readNotification) {
          dispatch(completeNotification(readNotification?.data));
        }
      }
      setIsLoading(false);
    }
  };

  const getVersionAnnotation = async (idFromData, version) => {
    const versionData = await getVersionAnnotationData(idFromData, version);
    if (versionData.length > 0) {
      const response = versionData[0]?.versions[0];
      const mapData = gridKeysValue
        ? versionData[0]?.mapped_result
        : versionData[0]?.mapped_result[0];
      const mapMergedData = gridKeysValue
        ? mapData
        : Object.keys(mapData).reduce(
            (acc, key) => [...acc, ...mapData[key]],
            [],
          );
      setMappedResult(mapMergedData);
      const annotationData = response?.annotation_data;
      if (annotationData) {
        const mergedData = gridKeysValue
          ? annotationData
          : Object.keys(annotationData[0]).reduce(
              (acc, key) => [...acc, ...annotationData[0][key]],
              [],
            );
        mergedData.forEach((a) => {
          if (a?.product) {
            setProductCount(a?.product);
          } else if (a?.transaction) {
            setProductCount(a?.transaction);
          }
        });

        setData(annotationData);
        setIsLoading(false);
      }
      const url = versionData[0]?.url;
      setInvoiceImg(url);
      setImageCount(url.length);
      const imageObjects = Array.from(
        { length: url.length },
        () => new window.Image(),
      );
      setImageUrl(imageObjects);
      setIsLoading(false);
    }
  };

  const getVersions = async (paramsId) => {
    const response = await getAllVersion({}, '', {}, {}, paramsId);

    const version = response.find(
      (versionData) =>
        versionData.invoice_id === id &&
        versionData.version === params?.version,
    );

    if (version) {
      setVersionId(version.id);
    } else {
      setVersionId('');
    }
  };

  const getAllDataFields = async () => {
    const responses = checkedDataFields;
    if (responses) {
      Object.keys(responses).forEach((response) => {
        if (response === 'Customer') {
          setCustomerData(responses[response]);
        } else if (response === 'Invoice' || response === 'Receipt') {
          setInvoiceReceiptData(responses[response]);
        } else if (response === 'Payment') {
          setPaymentData(responses[response]);
        } else if (response === 'Payment_Method') {
          setPaymentMethodData(responses[response]);
        } else if (response === 'Supplier') {
          setSupplierData(responses[response]);
        } else if (response === 'Product') {
          setProductData(responses[response]);
        } else if (response === 'bank_details') {
          setBankDetails(responses[response]);
        } else if (response === 'Card_Holder') {
          setCardHolder(responses[response]);
        } else if (response === 'Card_Info') {
          setCardInfo(responses[response]);
        } else if (response === 'Account_Holder_Details') {
          setAccountHolderDetails(responses[response]);
        } else if (response === 'Statement_Details') {
          setStatementDetails(responses[response]);
        } else if (response === 'Summary') {
          setSummary(responses[response]);
        } else if (response === 'Bank_Charges') {
          setBankCharges(responses[response]);
        } else if (response === 'Statement') {
          setStatement(responses[response]);
        } else if (response === 'Transactions') {
          setTransactionData(responses[response]);
        } else if (response === 'Gst_Info') {
          setGSTInfo(responses[response]);
        }
      });
    }
  };

  useEffect(() => {
    getAllDataFields();
  }, [checkedDataFields]);
  useEffect(() => {
    const responses = dataProductAndTransaction;
    if (responses) {
      Object.keys(responses).forEach((response) => {
        if (response === 'Product') {
          setProductDataGrid(responses[response]);
        } else if (response === 'Transactions') {
          setTransactionDataGrid(responses[response]);
        }
      });
    }
  }, [dataProductAndTransaction]);
  useEffect(() => {
    if ((versionId === '' || isEditing) && transformBox && hoverId !== '') {
      transformRef.current.forEach((transformer, i) => {
        if (transformer?.nodes) {
          const node = shapeRef.current[i];
          transformer.nodes([node]);
          transformer.getLayer().batchDraw();
        }
      });
    }
  }, [transformBox, hoverId]);

  const randomStr = randomstring.generate(6);

  const handleMouseEnter = (event) => {
    const { target } = event;
    if (versionId === '' || isEditing) {
      target.getStage().container().style.cursor = 'crosshair';
    } else {
      target.getStage().container().style.cursor = 'default';
    }
  };

  const handleMouseDown = (event, images, pageUrl, pageNum) => {
    if (
      (versionId === '' || isEditing) &&
      tooltipId === '' &&
      newAnnotation.length === 0
    ) {
      const { x, y } = event.target.getStage().getPointerPosition();
      setCurrentPageImage(pageUrl);
      setCurrentPageNumber(pageNum);
      setNewAnnotation([
        {
          x,
          y,
          width: 0,
          height: 0,
          id: randomStr,
        },
      ]);
    }
  };

  const handleMouseUp = async (event, images, pageUrl, pageNum) => {
    if (newAnnotation.length === 1) {
      const sx = newAnnotation[0].x;
      const sy = newAnnotation[0].y;
      const { x, y } = event.target.getStage().getPointerPosition();
      const annotationToAdd = {
        x: sx,
        y: sy,
        width: x - sx,
        height: y - sy,
        id: randomStr,
        color: newAnnotationColor,
      };
      const imageSizeAnnotationToAdd = {
        x: sx / (originalImageSize.width / pageUrl.width),
        y: sy / (originalImageSize.height / pageUrl.height),
        width: (x - sx) / (originalImageSize.width / pageUrl.width),
        height: (y - sy) / (originalImageSize.height / pageUrl.height),
        id: randomStr,
      };
      setNewAnnotation([]);
      if (annotationToAdd.width !== 0 && annotationToAdd.height !== 0) {
        data[0][pageNum].push(annotationToAdd);
        setDialogOpen(true);
        setSelectedBox(imageSizeAnnotationToAdd);
        setTransformBox(annotationToAdd);
        setCurrentPageImage(pageUrl);
        setCurrentPageNumber(pageNum);
        const annotationData = await getNewBoxAnnotationData(
          images,
          imageSizeAnnotationToAdd,
        );
        if (annotationData) {
          const updatedValue = annotationData.value.replace(/[\n\f]/g, '');
          const updatedAnnotations = data[0];
          Object.entries(updatedAnnotations).forEach(
            ([pageKey, annotations]) => {
              updatedAnnotations[pageKey] = annotations.map((box) =>
                box.id === annotationData.coordinate.id
                  ? { ...box, value: updatedValue }
                  : box,
              );
            },
          );
          setData([updatedAnnotations]);
          setOpenedData([updatedAnnotations]);
        }
      }
    }
  };

  const handleMouseMove = (event, images, pageUrl, pageNum) => {
    if (newAnnotation.length === 1) {
      setTransformBox(null);
      const sx = newAnnotation[0].x;
      const sy = newAnnotation[0].y;
      const { x, y } = event.target.getStage().getPointerPosition();
      setCurrentPageImage(pageUrl);
      setCurrentPageNumber(pageNum);
      setNewAnnotation([
        {
          x: sx,
          y: sy,
          width: x - sx,
          height: y - sy,
          id: newAnnotation[0].id,
          color: newAnnotationColor,
        },
      ]);
    }
  };

  const handleBoxClick = (value, currentImage, page) => {
    // and open a popup with the data
    setCurrentPageImage(currentImage);
    setCurrentPageNumber(page);
    if (transformBox !== null && transformBox.id === hoverId) {
      setSelectedBox(null);
      if (versionId === '' || isEditing) {
        setTransformBox(null);
      }
      setDialogOpen(false);
    } else {
      setSelectedBox(value);
      if (versionId === '' || isEditing) {
        setTransformBox(value);
      }
      setDialogOpen(true);
    }
  };

  const annotationsToDraw = [...data, ...newAnnotation];
  useEffect(() => {
    // Ensure refs are initialized with the correct values
    let mergedData = annotationsToDraw;
    if (!gridKeysValue) {
      if (annotationsToDraw.length > 0) {
        mergedData = Object.keys(annotationsToDraw[0]).reduce(
          (acc, key) => [...acc, ...annotationsToDraw[0][key]],
          [],
        );
      }
    }

    shapeRef.current = shapeRef.current.slice(0, mergedData.length);
    transformRef.current = transformRef.current.slice(0, mergedData.length);
  }, [annotationsToDraw]);

  const rectMouseEnter = (event) => {
    const { target } = event;
    if (versionId === '' || isEditing) {
      target.getStage().container().style.cursor = 'move';
    } else {
      target.getStage().container().style.cursor = 'pointer';
    }
  };

  const rectMouseLeave = (event) => {
    const { target } = event;
    if (versionId === '' || isEditing) {
      target.getStage().container().style.cursor = 'crosshair';
    } else {
      target.getStage().container().style.cursor = 'default';
    }
    setHoverId('');
    setTooltipId('');
    setNewAnnotation([]);
  };

  const handleMouseOver = (value) => {
    textRef.current = value.short_desc;
    if (value.label) {
      setHoverId(value.id);
    }
    setTooltipId(value.id);

    if (value.version === latestVersion && value.validated) {
      setHoverRectFillColor(lightPalette.forestGreen.light);
    } else if (value.version !== latestVersion && value.validated) {
      setHoverRectFillColor(lightPalette.orange.light);
    } else {
      setHoverRectFillColor(lightPalette.orange.light);
    }
  };

  const handleDragStart = () => {
    setIsDragging(true);
    setSelectedBox(null);
    setDialogOpen(false);
  };
  const createUpdatedAnnotationData = (newData, ids, newX, newY, pageNum) => {
    const page = newData[0];
    let newPayload = null;
    return {
      ...page,
      [pageNum]: page[pageNum].map((item) => {
        if (item.id === ids) {
          newPayload = { ...item, x: newX, y: newY };
          return newPayload;
        }
        return {
          updatedAnnotations: item,
          newValue: newPayload,
        };
      }),
    };
  };
  const handleDragMove = async (event, images, pageUrl, pageNum) => {
    if (isDragging) {
      setDialogOpen(false);
      setSelectedBox(null);
      setCurrentPageImage(pageUrl);
      setCurrentPageNumber(pageNum);
      const { x, y } = event.target.attrs;
      const xValue = x / (originalImageSize.width / pageUrl.width);
      const yValue = y / (originalImageSize.height / pageUrl.height);
      const newData = await createUpdatedAnnotationData(
        data,
        hoverId,
        xValue,
        yValue,
        pageNum,
      );

      setDraggedBox(newData.newPayload);
      setData(newData.updatedAnnotations);
    }
  };

  const handleDragEnd = async (event, images, pageUrl, pageNum) => {
    if (draggedBox) {
      setCurrentPageImage(pageUrl);
      setCurrentPageNumber(pageNum);
      const annotationData = await getNewBoxAnnotationData(images, draggedBox);
      setPopUpLoader(false);
      if (annotationData) {
        const updatedValue = annotationData.value.replace(/[\n\f]/g, '');
        const updatedAnnotations = data[0];
        Object.entries(updatedAnnotations).forEach(([pageKey, annotations]) => {
          updatedAnnotations[pageKey] = annotations.map((box) =>
            box.id === annotationData.coordinate.id
              ? { ...box, value: updatedValue }
              : box,
          );
        });
        setData(updatedAnnotations);
        setOpenedData(updatedAnnotations);
        Toast({
          message: `${draggedBox.label} is updated`,
          variant: 'success',
        });
        setPopUpLoader(true);
        setDraggedBox(null);
      }
    }
    setIsDragging(false);
    setSelectedBox(null);
    setTransformBox(null);
    setDialogOpen(false);
    setIsUpdatedData(false);
    setIsUpdatedData(true);
  };

  const getTextWidth = (text, font) => {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    context.font = font;
    const { width } = context.measureText(text);
    return width;
  };

  useEffect(() => {
    if (id) {
      if (
        location.pathname === `/invoice/${id}` ||
        location.pathname === `/receipt/${id}` ||
        location.pathname === `/sale/${id}` ||
        location.pathname === `/creditcardstatement/${id}` ||
        location.pathname === `/bank-statement/${id}`
      ) {
        getDocAnnotation(id);
        setVersionId('');
      } else if (
        (isEditing === null &&
          (location.pathname === `/invoice/${params?.version}/${id}` ||
            location.pathname === `/receipt/${params?.version}/${id}` ||
            location.pathname === `/sale/${params?.version}/${id}` ||
            location.pathname ===
              `/creditcardstatement/${params?.version}/${id}` ||
            location.pathname ===
              `/bank-statement/${params?.version}/${id}`)) ||
        isEditing
      ) {
        getVersions(id);
        if (versionId) {
          getVersionAnnotation(id, versionId);
        }
      }
    }
  }, [id, versionId, versionChange]);

  useEffect(() => {
    if (invoiceImg.length !== 0 && imageUrl !== null) {
      imageUrl.forEach((img, index) => {
        const images = img;
        if (index < invoiceImg.length) {
          images.src = invoiceImg[index];
        }
      });
    }
  }, [invoiceImg, imageUrl]);

  useEffect(() => {
    if (imageUrl.length !== 0) {
      imageUrl.onload = () => {
        imageUrl.forEach((img, index) => {
          setImageSize({
            width: imageUrl[index].width,
            height: imageUrl[index].height,
          });
        });
      };
    }
    if (imageUrl.length !== 0) {
      imageUrl.forEach((img, index) => {
        setImageSize({
          width: imageUrl[index].width * 2.8,
          height: imageUrl[index].height * 2.8,
        });
      });
    }
    console.log('imageSize', imageSize);
  }, [imageUrl]);

  const getProducts = () => {
    const productsItems = [];
    const currentProductCount = productCount;
    const mergedData = gridKeysValue
      ? data
      : Object.keys(data[0]).reduce(
          (acc, key) => [...acc, ...data[0][key]],
          [],
        );
    for (let i = 1; i <= currentProductCount; i += 1) {
      const product = mergedData.filter((d) => d.product === i);
      productsItems.push(product);
    }
    setProducts(productsItems);
  };

  const getTransactions = () => {
    const transactionsItems = [];
    const currentTransactionCount = transactionCount;
    const mergedData = gridKeysValue
      ? data
      : Object.keys(data[0]).reduce(
          (acc, key) => [...acc, ...data[0][key]],
          [],
        );
    for (let i = 1; i <= currentTransactionCount; i += 1) {
      const transactions = mergedData.filter((d) => d.product === i);
      transactionsItems.push(transactions);
    }
    setTransactions(transactionsItems);
  };

  useEffect(() => {
    if (data.length > 0) {
      getProducts();
      getTransactions();
    }
  }, [data]);

  // function for sending data to node after changing its values
  const updateOpenedData = async (updatedData, existingData) => {
    const responses = checkedDataFields;
    // function for sending data to node after changing its values
    Object.keys(checkedDataFields).forEach((group) => {
      const response = checkedDataFields[group];
      const updatedAnnotationData = updatedData;

      response.forEach((dataField) => {
        const responseDataField = dataField;
        if (dataField.short_desc === updatedData.label) {
          if (dataField.annotation_field) {
            updatedAnnotationData.label = dataField.annotation_field;
          } else {
            responseDataField.annotation_field = dataField.short_desc;
            updatedAnnotationData.label = dataField.annotation_field;
          }
        }
      });
    });
    setCheckedDataFields(responses);
    const replacedData =
      existingData && existingData.length > 0 ? existingData : [...data];
    if (gridKeysValue) {
      let currentPageData = replacedData;
      let dataIndex;
      if (updatedData?.product) {
        dataIndex = currentPageData.findIndex(
          (item) =>
            item.label === updatedData.label &&
            item?.product === updatedData.product,
        );
      } else {
        dataIndex = currentPageData.findIndex(
          (item) => item.label === updatedData.label,
        );
      }
      if (dataIndex !== -1) {
        if (updatedData.value !== '') {
          currentPageData[dataIndex] = updatedData;

          if (existingData && existingData.length > 0) {
            setData(replacedData);
            setIsUpdatedData(true);
          } else if (existingData === undefined && updatedData.value !== '') {
            setData(replacedData);
            setIsUpdatedData(true);
          }
        } else {
          currentPageData = currentPageData.filter(
            (item) => item.label !== updatedData.label,
          );
          setIsUpdatedData(true);
        }
      } else if (updatedData.value !== '') {
        let isAvailable;
        if (updatedData?.product) {
          isAvailable = replacedData.some(
            (elem) =>
              elem.label === updatedData.label &&
              elem?.product &&
              elem.product === updatedData.product,
          );
        } else {
          isAvailable = replacedData.some(
            (elem) => elem.label === updatedData.label,
          );
        }
        if (!isAvailable) {
          currentPageData.push(updatedData); // Add the new item to the current page
          setData(replacedData); // Update the state with the new data
          setIsUpdatedData(true);
        }
      }
    } else {
      const pageData = replacedData[0];

      Object.keys(pageData).forEach((pageKey) => {
        const currentPageData = pageData[pageKey];

        let dataIndex;
        if (updatedData?.product) {
          dataIndex = currentPageData.findIndex(
            (item) =>
              item.label === updatedData.label &&
              item?.product === updatedData.product,
          );
        } else {
          dataIndex = currentPageData.findIndex(
            (item) => item.label === updatedData.label,
          );
        }
        if (dataIndex !== -1) {
          if (updatedData.value !== '') {
            currentPageData[dataIndex] = updatedData;

            if (existingData && existingData.length > 0) {
              setData(replacedData);
              setIsUpdatedData(true);
            } else if (existingData === undefined && updatedData.value !== '') {
              setData(replacedData);
              setIsUpdatedData(true);
            }
          } else {
            pageData[pageKey] = currentPageData.filter(
              (item) => item.label !== updatedData.label,
            );
            setIsUpdatedData(true);
          }
        } else if (updatedData.value !== '') {
          const mergedData = Object.keys(replacedData[0]).reduce(
            (acc, key) => [...acc, ...replacedData[0][key]],
            [],
          );
          let isAvailable;
          if (updatedData?.product) {
            isAvailable = mergedData.some(
              (elem) =>
                elem.label === updatedData.label &&
                elem?.product &&
                elem.product === updatedData.product,
            );
          } else {
            isAvailable = mergedData.some(
              (elem) => elem.label === updatedData.label,
            );
          }

          if (!isAvailable) {
            currentPageData.push(updatedData); // Add the new item to the current page
            setData(replacedData); // Update the state with the new data
            setIsUpdatedData(true);
          }
        }
      });
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (
          isUpdatedData &&
          (location.pathname === `/invoice/${id}` ||
            location.pathname === `/receipt/${id}` ||
            location.pathname === `/sale/${id}` ||
            location.pathname === `/creditcardstatement/${id}` ||
            location.pathname === `/bank-statement/${id}`)
        ) {
          const validateDocResponse = await validateDoc(data, id);

          const specificVersionValidateResponse = await specificVersionValidate(
            data,
            id,
            selectedVersionId,
          );

          if (!validateDocResponse && !specificVersionValidateResponse) {
            getDocAnnotation(id);
          }

          setIsUpdatedData(false);
        } else if (isUpdatedData && isEditing) {
          const specificVersionValidateResponse = await specificVersionValidate(
            data,
            id,
            versionId,
          );
          if (!specificVersionValidateResponse) {
            getVersionAnnotation(id, versionId);
          }

          setIsUpdatedData(false);
        }
      } catch (error) {
        return error;
      }
    };
    fetchData();
  }, [isUpdatedData]);

  const validateDocument = async () => {
    if (isEditing) {
      const getFileName = invoiceImg[currentPageIndex].split('/')[4];
      const parts = getFileName.split('-');
      if (invoiceImg[currentPageIndex]) {
        let fileName;
        if (parts.length >= 2) {
          fileName = parts.slice(1).join('-');
        }

        const response = await axios.get(invoiceImg[currentPageIndex], {
          responseType: 'blob',
        });
        const blob = new Blob([response.data], {
          type: response.headers['content-type'],
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        let navigateTo;
        switch (true) {
          case location?.pathname.includes('invoice'):
            navigateTo = '/invoices';
            break;
          case location?.pathname.includes('sale'):
            navigateTo = '/sales';
            break;
          case location?.pathname.includes('receipt'):
            navigateTo = '/receipts';
            break;
          case location?.pathname.includes('creditcardstatement'):
            navigateTo = '/creditcardstatements';
            break;
          case location?.pathname.includes('bank-statement'):
            navigateTo = '/bank-statements';
            break;
          default:
            navigateTo = '/home'; // Optional: default route
        }

        navigate(navigateTo);
      }
    } else {
      setExportDocumentOpen(true);
    }
  };
  const getFilterSortData = async () => {
    try {
      const response = await getGridFilterSortStatus('Transactions');
      setGridSettingData(response);
    } catch (err) {
      return err;
    }
  };

  useEffect(() => {
    getFilterSortData();
  }, []);
  useEffect(() => {
    if (data.length > 0) {
      const mergedData = gridKeysValue
        ? data
        : Object.keys(data[0]).reduce(
            (acc, key) => [...acc, ...data[0][key]],
            [],
          );
      const different = mergedData.filter((obj1) => {
        if (obj1.product !== undefined) {
          return mappedResult.some(
            (obj2) =>
              obj1.product === obj2.product &&
              obj1.validated === true &&
              obj1.version === latestVersion,
          );
        }
        if (obj1.product) {
          return mappedResult.some(
            (obj2) =>
              obj1.product === obj2.product &&
              obj1.validated === true &&
              obj1.version === latestVersion,
          );
        }
        if (obj1.label) {
          return mappedResult.some(
            () => obj1.validated === true && obj1.version === latestVersion,
          );
        }
        return mappedResult.some(
          (obj2) =>
            obj1.label === obj2.label &&
            obj1.validated === true &&
            obj1.version === latestVersion,
        );
      });

      setChangedData(different);
    }
  }, [mappedResult, data, isUpdatedData, latestVersion]);

  const CloseExportDocument = () => {
    setExportDocumentOpen(false);
    setSaveAndExitOpen(false);
    setExportToXmlOpen(false);
    setExportToJsonOpen(false);
    setSaveOpen(false);
  };

  const handleSidebarMouseOver = (value) => {
    handleMouseOver(value);
  };

  const handleSidebarMouseLeave = () => {
    setHoverId('');
    setTooltipId('');
    setNewAnnotation([]);
  };

  const getOpenedData = (boxId, currentPage) => {
    if (data.length > 0 && currentPage) {
      data[0][currentPage].forEach((d) => {
        if (d.id === boxId) {
          return setOpenedData(d);
        }
        return null;
      });
    }
  };

  const removeAnnotation = (boxId) => {
    const newData = JSON.parse(JSON.stringify(data));
    const firstPageObj = newData[0];
    Object.keys(firstPageObj).forEach((pageKey) => {
      firstPageObj[pageKey] = firstPageObj[pageKey].filter(
        (item) => item.id !== boxId,
      );
    });
    setData(newData);
    setIsUpdatedData(true);
    setTransformBox(null);
    setNewAnnotation([]);
    setDialogOpen(false);
    setTooltipId('');
    if (openedData?.label) {
      Toast({ message: ANNOTATION_TOAST.DATA_REMOVED, variant: 'success' });
    }
  };

  const handleTransform = () => {
    setTooltipId(transformBox.id);
    setNewAnnotation([]);
    setTransformBox(transformBox);
  };

  const getFillColor = (value, fillHoverId, fillLatestVersion) => {
    if (!value.label) {
      return null;
    }

    if (fillHoverId === value.id) {
      return hoverRectFillColor;
    }

    if (value.version === fillLatestVersion && value.validated) {
      return lightPalette.forestGreen.lightest;
    }

    if (value.version !== fillLatestVersion && value.validated) {
      return lightPalette.orange.lightest;
    }

    return lightPalette.orange.lightest;
  };

  const getStrokeColor = (value, strokeLatestVersion) => {
    if (value.version === strokeLatestVersion && value.validated) {
      return validateColor;
    }
    if (value.version !== strokeLatestVersion && value.validated) {
      return initialDataColor;
    }
    return value.color || initialDataColor;
  };

  const getAnchorFillColor = (value, version) => {
    if (value.version === version && value.validated) {
      return validateColor;
    }
    if (value.version !== version && value.validated) {
      return initialDataColor;
    }
    return value.color || initialDataColor;
  };

  const getLabelFillColor = (value, version) => {
    if (value.validated) {
      return value.version === version
        ? 'rgba(38, 194, 129, 1)'
        : lightPalette.orange.main;
    }
    return lightPalette.orange.main;
  };

  let buttonText;

  if (isEditing) {
    buttonText = INVOICE.VERSION_EDITING_TEXT;
  } else if (versionId !== '' && isEditing === null) {
    buttonText = INVOICE.VERSION_BUTTON_TEXT;
  } else {
    buttonText = INVOICE.BUTTON_TEXT;
  }
  let basePath;

  switch (true) {
    case location?.pathname.includes('invoice'):
      basePath = '/invoice';
      break;
    case location?.pathname.includes('sale'):
      basePath = '/sale';
      break;
    case location?.pathname.includes('receipt'):
      basePath = '/receipt';
      break;
    case location?.pathname.includes('creditcardstatement'):
      basePath = '/creditcardstatement';
      break;
    case location?.pathname.includes('bank-statement'):
      basePath = '/bank-statement';
      break;
    default:
      basePath = '/invoice';
  }
  let confirmButtonUrl;
  if (versionId !== '') {
    confirmButtonUrl = `${basePath}/${params?.version}/${id}?editing=true`;
  } else {
    confirmButtonUrl = null;
  }

  let buttonComponent;
  if (versionId !== '') {
    buttonComponent = Link;
  } else {
    buttonComponent = 'button';
  }
  const getIconComponent = (idOfVersion, editing) => {
    if (idOfVersion !== '' && editing === null) {
      return (
        <Box
          component="img"
          src={Edit}
          alt="Edit"
          className={classes.checkCircleIcon}
        />
      );
    }
    return (
      <Box
        component="img"
        src={checkCircle}
        alt="check-circle"
        className={classes.checkCircleIcon}
      />
    );
  };

  const validateBtnOnClick = (idOfVersion, editing) => {
    if (changedData.length > 0) {
      return validateDocument();
    }
    if (changedData.length === 0) {
      Toast({
        message: ANNOTATION.INVOICE_ANNOTATION_MESSAGE.NO_CHANGES_DETECTED,
        variant: 'warning',
      });
    }
    if (idOfVersion !== '' && editing === null) {
      return null;
    }
  };
  const handleOnChange = (previousSlide) => {
    setCurrentPageIndex(previousSlide);
  };

  // Combine and filter the data
  // const existingData = [
  //   { title: 'Invoice', data: invoiceReceiptData },
  //   { title: 'Supplier', data: supplierData },
  //   { title: 'Customer', data: customerData },
  //   { title: 'Payment', data: paymentData },
  //   { title: 'Payment Method', data: paymentMethodData },
  //   { title: 'Bank Details', data: bankDetails },
  //   { title: 'Card Holder', data: cardHolder },
  //   { title: 'Card Info', data: cardInfo },
  //   { title: 'Account Holder Details', data: accountHolderDetails },
  //   { title: 'Statement Details', data: statementDetails },
  //   { title: 'Summary', data: summary },
  //   { title: 'Bank Charges', data: bankCharges },
  //   { title: 'Statement', data: statement },
  //   { title: 'Transaction', data: transactionData },
  //   { title: 'GST Info', data: GSTInfo },
  //   { title: 'productData', data: productData },
  // ].filter((section) => {
  //   const isBankOrCreditCard = location?.pathname.includes('bank-statement') || location?.pathname.includes('creditcardstatement');
  //   return section.data && section.data.length > 0 && !(isBankOrCreditCard && section.title === 'Transaction');
  // });

  // Split existing data into two parts
  // const middleIndex = Math.ceil(existingData.length / 2);
  // const leftColumnData = existingData.slice(0, middleIndex);
  // const rightColumnData = existingData.slice(middleIndex);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };
  useEffect(() => {
    switch (true) {
      case location?.pathname.includes('invoice'):
        setTabSectionItem(InvoiceTabData);
        break;
      case location?.pathname.includes('sale'):
        setTabSectionItem(SalesTabData);
        break;
      case location?.pathname.includes('receipt'):
        setTabSectionItem(ReceiptTabData);
        break;
      case location?.pathname.includes('creditcardstatement'):
        setTabSectionItem(CreditCardTabData);
        break;
      case location?.pathname.includes('bank-statements'):
        setTabSectionItem(TabData);
        break;
      default:
        setTabSectionItem(TabData);
    }
  }, []);
  const getColumnData = () => {
    if (
      location?.pathname.includes('invoice') ||
      location?.pathname.includes('sale') ||
      location?.pathname.includes('receipt')
    ) {
      return paymentColumnDef;
    }
    if (
      location?.pathname.includes('bank-statement') ||
      location?.pathname.includes('creditcardstatement')
    ) {
      return transactionColumnDef;
    }
    return []; // Default return if no condition matches
  };

  const gridColumnMergeData = (arr1, arr2) => {
    if (arr1.length && arr2.length) {
      return arr1.map((item) => {
        const match = arr2.find((d2) => d2.id === item.id);
        if (match) {
          return {
            ...item,
            annotation_field: match?.annotation_field,
          };
        }
        return item;
      });
    }
    return [];
  };
  const getTransactionData = () => {
    if (
      location?.pathname.includes('invoice') ||
      location?.pathname.includes('sale') ||
      location?.pathname.includes('receipt')
    ) {
      return gridColumnMergeData(productDataGrid, productData);
    }
    if (
      location?.pathname.includes('bank-statement') ||
      location?.pathname.includes('creditcardstatement')
    ) {
      return gridColumnMergeData(transactionDataGrid, transactionData);
    }
    return []; // Default return if no condition matches
  };
  const ConfirmationDeletePopup = () => {
    setIsConfirmationDialogOpen(true);
  };
  const handleCloseDialog = () => {
    setIsConfirmationDialogOpen(false);
  };
  const handleConfirmAction = async () => {
    if (id !== null) {
      const response = await deleteDocument({ id });
      if (response) {
        Toast({
          message: 'Document deleted successfully',
          variant: 'success',
        });
        let navigateTo;
        switch (true) {
          case location?.pathname.includes('invoice'):
            navigateTo = '/invoices';
            break;
          case location?.pathname.includes('sale'):
            navigateTo = '/sales';
            break;
          case location?.pathname.includes('receipt'):
            navigateTo = '/receipts';
            break;
          case location?.pathname.includes('creditcardstatement'):
            navigateTo = '/creditcardstatements';
            break;
          case location?.pathname.includes('bank-statement'):
            navigateTo = '/bank-statements';
            break;
          default:
            navigateTo = '/home'; // Optional: default route
        }

        navigate(navigateTo);
      }
    }

    handleCloseDialog();
  };

  useEffect(() => {
    const handleResizeScreen = () => {
      setIsSmallScreen(window.innerWidth < 1100);
    };

    window.addEventListener('resize', handleResizeScreen);
    return () => window.removeEventListener('resize', handleResizeScreen);
  }, []);
  return (
    <Root className={classes.root}>
      {isLoading ? (
        <Box className={classes.loaderBox}>
          <CircularProgress />
        </Box>
      ) : (
        <Box style={{ width: '100%' }}>
          <ResizeGrid
            setDimensions={setDimensions}
            isSmallScreen={isSmallScreen}
          >
            <Box className={classes.invoiceGridMainBox}>
              <AnnotationSubNav
                invoiceId={id}
                latestVersion={latestVersion}
                setLatestVersion={setLatestVersion}
                isEditing={isEditing}
                versionId={versionId}
                invoiceVersions={invoiceVersions}
                version={params?.version}
                setVersionChange={setVersionChange}
                setSelectedVersionId={setSelectedVersionId}
                imageCount={imageCount}
                carouselRef={carouselRef}
                currentPageIndex={currentPageIndex}
              />
              <Box ref={parentRef} className={classes.invoicePdfBox}>
                {originalImageSize.width !== '' &&
                  originalImageSize.height !== '' &&
                  latestVersion !== '' &&
                  imageUrl.length !== 0 && (
                    <Carousel
                      autoPlaySpeed={3000}
                      ref={carouselRef}
                      containerClass="container-with-dots"
                      draggable={false}
                      minimumTouchDrag={80}
                      beforeChange={handleOnChange}
                      pauseOnHover
                      responsive={{
                        desktop: {
                          breakpoint: {
                            max: 3000,
                            min: 1024,
                          },
                          items: 1,
                          partialVisibilityGutter: 40,
                        },
                      }}
                      shouldResetAutoplay
                      slidesToSlide={1}
                      arrows={false}
                    >
                      {imageUrl.map((pageDataUrl, index) => (
                        <Stage
                          key={`Page-${index + 1}`}
                          ref={stageRef}
                          onMouseDown={(e) => {
                            handleMouseDown(
                              e,
                              invoiceImg[index],
                              pageDataUrl,
                              invoiceImg[index],
                            );
                          }}
                          onMouseUp={(e) => {
                            handleMouseUp(
                              e,
                              invoiceImg[index],
                              pageDataUrl,
                              invoiceImg[index],
                            );
                          }}
                          onMouseMove={(e) => {
                            handleMouseMove(
                              e,
                              invoiceImg[index],
                              pageDataUrl,
                              invoiceImg[index],
                            );
                          }}
                          onMouseEnter={handleMouseEnter}
                          width={originalImageSize.width}
                          height={originalImageSize.height}
                        >
                          <Layer>
                            <Image
                              image={pageDataUrl}
                              scaleX={
                                originalImageSize.width / pageDataUrl.width
                              }
                              scaleY={
                                originalImageSize.height / pageDataUrl.height
                              }
                            />
                          </Layer>
                          {!gridKeysValue && (
                            <Layer>
                              {annotationsToDraw &&
                                annotationsToDraw.length > 0 &&
                                annotationsToDraw[0][invoiceImg[index]]?.map(
                                  (value, i) => (
                                    <Group key={value?.id}>
                                      <Rect
                                        key={value?.id}
                                        ref={(node) => {
                                          shapeRef.current[i] = node;
                                          return null;
                                        }}
                                        {...value}
                                        onTransform={handleTransform}
                                        onTransformEnd={async () => {
                                          const node = shapeRef.current[i];
                                          if (node) {
                                            const scaleX = node.scaleX();
                                            const scaleY = node.scaleY();
                                            node.scaleX(1);
                                            node.scaleY(1);

                                            const newAttrs = {
                                              ...value,
                                              x:
                                                node.x() /
                                                (originalImageSize.width /
                                                  pageDataUrl.width),
                                              y:
                                                node.y() /
                                                (originalImageSize.height /
                                                  pageDataUrl.height),
                                              width:
                                                (node.width() * scaleX) /
                                                (originalImageSize.width /
                                                  pageDataUrl.width),
                                              height:
                                                (node.height() * scaleY) /
                                                (originalImageSize.height /
                                                  pageDataUrl.height),
                                            };

                                            // Call your onChange function directly
                                            const page = data[0];
                                            const newPayload = {
                                              ...page,
                                              [invoiceImg[index]]: page[
                                                invoiceImg[index]
                                              ]?.map((elem, idx) => {
                                                if (idx === i) {
                                                  return {
                                                    ...elem,
                                                    ...newAttrs,
                                                  };
                                                }
                                                return elem;
                                              }),
                                            };
                                            setData(newPayload);
                                            const annotationData =
                                              await getNewBoxAnnotationData(
                                                invoiceImg[index],
                                                newAttrs,
                                              );
                                            setTooltipId('');
                                            setPopUpLoader(false);
                                            if (annotationData) {
                                              const updatedValue =
                                                annotationData.value.replace(
                                                  /[\n\f]/g,
                                                  '',
                                                );
                                              const updatedAnnotations =
                                                data[0];
                                              Object.entries(
                                                updatedAnnotations,
                                              ).forEach(
                                                ([pageKey, annotations]) => {
                                                  updatedAnnotations[pageKey] =
                                                    annotations?.map((box) =>
                                                      box.id ===
                                                      annotationData.coordinate
                                                        .id
                                                        ? {
                                                            ...box,
                                                            x: newAttrs.x,
                                                            y: newAttrs.y,
                                                            width:
                                                              newAttrs.width,
                                                            height:
                                                              newAttrs.height,
                                                            value: updatedValue,
                                                          }
                                                        : box,
                                                    );
                                                },
                                              );
                                              setData(updatedAnnotations);
                                              setOpenedData(updatedAnnotations);
                                              Toast({
                                                message: `${newAttrs.label} is updated`,
                                                variant: 'success',
                                              });
                                              setPopUpLoader(true);
                                              setIsUpdatedData(true);
                                            }
                                          }
                                        }}
                                        x={
                                          value.label !== undefined
                                            ? value.x *
                                              (originalImageSize.width /
                                                pageDataUrl.width)
                                            : value.x
                                        }
                                        y={
                                          value.label !== undefined
                                            ? value.y *
                                              (originalImageSize.height /
                                                pageDataUrl.height)
                                            : value.y
                                        }
                                        width={
                                          value.label !== undefined
                                            ? value.width *
                                              (originalImageSize.width /
                                                pageDataUrl.width)
                                            : value.width
                                        }
                                        height={
                                          value.label !== undefined
                                            ? value.height *
                                              (originalImageSize.height /
                                                pageDataUrl.height)
                                            : value.height
                                        }
                                        fill={getFillColor(
                                          value,
                                          hoverId,
                                          latestVersion,
                                        )}
                                        stroke={getStrokeColor(
                                          value,
                                          latestVersion,
                                        )}
                                        onClick={() =>
                                          handleBoxClick(
                                            value,
                                            imageUrl[index],
                                            invoiceImg[index],
                                          )
                                        }
                                        strokeWidth={1} // Adjust the width of the border
                                        dash={
                                          value.label === undefined
                                            ? [5, 5]
                                            : null
                                        }
                                        cornerRadius={
                                          value.label !== undefined &&
                                          value.width > 0 &&
                                          value.height > 0
                                            ? 5
                                            : 0
                                        }
                                        onMouseOver={() =>
                                          handleMouseOver(value)
                                        }
                                        onMouseEnter={rectMouseEnter}
                                        onMouseLeave={rectMouseLeave}
                                        draggable={
                                          versionId === '' || isEditing
                                        }
                                        onDragStart={handleDragStart}
                                        onDragMove={(e) => {
                                          handleDragMove(
                                            e,
                                            invoiceImg[index],
                                            pageDataUrl,
                                            invoiceImg[index],
                                          );
                                        }}
                                        onDragEnd={(e) => {
                                          handleDragEnd(
                                            e,
                                            invoiceImg[index],
                                            pageDataUrl,
                                            invoiceImg[index],
                                          );
                                        }}
                                      />
                                      {transformBox?.label &&
                                        transformBox?.id === value?.id && (
                                          <Transformer
                                            key={`transformer-${value.id}`} // Ensure a unique key for each Transformer
                                            ref={(node) => {
                                              transformRef.current[i] = node;
                                              return null;
                                            }}
                                            rotateEnabled={false}
                                            boundBoxFunc={(oldBox, newBox) => {
                                              // limit resize
                                              if (
                                                Math.abs(newBox.width) < 5 ||
                                                Math.abs(newBox.height) < 5
                                              ) {
                                                return oldBox;
                                              }
                                              return newBox;
                                            }}
                                            anchorFill={getAnchorFillColor(
                                              value,
                                              latestVersion,
                                            )}
                                            anchorSize={8}
                                          />
                                        )}
                                      {hoverId === value.id &&
                                        value.x &&
                                        value.y && (
                                          <>
                                            <Rect
                                              x={
                                                value.x *
                                                  (originalImageSize.width /
                                                    pageDataUrl.width) +
                                                10
                                              }
                                              y={
                                                shapeRef.current[i] &&
                                                shapeRef.current[
                                                  i
                                                ].getAbsolutePosition().y +
                                                  value.height *
                                                    (originalImageSize.height /
                                                      pageDataUrl.height) +
                                                  1 // Adjust the offset as needed
                                              }
                                              width={
                                                getTextWidth(
                                                  value?.short_desc,
                                                  textRef.current?.font,
                                                ) + 30
                                              } // Adjust width as needed
                                              height={22} // Adjust height as needed
                                              fill={getLabelFillColor(
                                                value,
                                                latestVersion,
                                              )} // Set the background color of the tooltip-like rect
                                              cornerRadius={5} // Set the radius of the corners
                                            />
                                            <Text
                                              x={
                                                value.x *
                                                  (originalImageSize.width /
                                                    pageDataUrl.width) +
                                                20
                                              }
                                              y={
                                                shapeRef.current[i] &&
                                                shapeRef.current[
                                                  i
                                                ].getAbsolutePosition().y +
                                                  value.height *
                                                    (originalImageSize.height /
                                                      pageDataUrl.height) +
                                                  5 // Adjust the offset as needed
                                              }
                                              text={`${value?.short_desc}`}
                                              fill="black" // Set the text color
                                              ref={textRef}
                                            />
                                          </>
                                        )}
                                    </Group>
                                  ),
                                )}
                            </Layer>
                          )}
                        </Stage>
                      ))}
                    </Carousel>
                  )}
              </Box>

              {!isDragging && selectedBox && isDialogOpen && (
                <Input
                  openedData={openedData}
                  getOpenedData={getOpenedData}
                  selectedId={selectedBox?.id}
                  setSelectedId={setSelectedBox}
                  updateOpenedData={updateOpenedData}
                  removeAnnotation={removeAnnotation}
                  data={data}
                  checkedDataFields={checkedDataFields}
                  setCheckedDataFields={setCheckedDataFields}
                  setOpenedData={setOpenedData}
                  setData={setData}
                  products={products}
                  transactions={Transactions}
                  changedData={changedData}
                  versionId={versionId}
                  isEditing={isEditing}
                  setTransformBox={setTransformBox}
                  setDialogOpen={setDialogOpen}
                  setNewAnnotation={setNewAnnotation}
                  setTooltipId={setTooltipId}
                  originalImageSize={originalImageSize}
                  imageUrl={currentPageImage}
                  selectedVersion={latestVersion}
                  popUpLoader={popUpLoader}
                  setPopUpLoader={setPopUpLoader}
                  selectedBox={selectedBox}
                  locationData={locationData}
                  currentPageNumber={currentPageNumber}
                />
              )}
            </Box>
            <Box className={classes.invoiceGrid} style={{ height: '100%' }}>
              <Box style={{ height: '100%' }}>
                <TabContext value={tabValue}>
                  <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <TabList
                      onChange={handleTabChange}
                      aria-label="lab API tabs example"
                      style={{ textTransform: 'none' }}
                    >
                      {tabSectionItem.map((elem, index) => (
                        <Tab
                          key={`${index + 1}`}
                          style={{
                            fontWeight: 500,
                            padding: '1rem 4rem',
                            textTransform: 'none',
                          }}
                          label={elem.label}
                          value={elem.index}
                        />
                      ))}
                    </TabList>
                  </Box>
                  <TabPanel
                    value="1"
                    style={{
                      height: '100%',
                      padding: '0px',
                      paddingTop: '30px',
                    }}
                  >
                    {' '}
                    <Box className={classes.invoiceGridInnerBox}>
                      <Box className={classes.invoiceGridBox}>
                        <Box className={classes.invoiceRecordBox}>
                          {invoiceReceiptData?.length > 0 && (
                            <Typography
                              variant="body2"
                              className={classes.invoiceRecordTitle}
                            >
                              Invoice
                            </Typography>
                          )}
                          {invoiceReceiptData?.length > 0 &&
                            invoiceReceiptData.map((invoice) => {
                              const fieldName = invoice?.short_desc;
                              const annotationField = invoice?.annotation_field;
                              return (
                                <DocumentRecord
                                  key={invoice.id}
                                  fieldName={fieldName}
                                  data={data}
                                  setData={setData}
                                  updateOpenedData={updateOpenedData}
                                  annotationField={annotationField}
                                  changedData={changedData}
                                  versionId={versionId}
                                  isEditing={isEditing}
                                  handleSidebarMouseOver={
                                    handleSidebarMouseOver
                                  }
                                  handleSidebarMouseLeave={
                                    handleSidebarMouseLeave
                                  }
                                  selectedVersion={latestVersion}
                                />
                              );
                            })}
                        </Box>

                        <Box className={classes.invoiceRecordBox}>
                          {supplierData?.length > 0 && (
                            <Typography
                              variant="body2"
                              className={classes.invoiceRecordTitle}
                            >
                              Supplier
                            </Typography>
                          )}
                          {supplierData?.length > 0 &&
                            supplierData.map((supplier) => {
                              const fieldName = supplier?.short_desc;
                              const annotationField =
                                supplier?.annotation_field;
                              return (
                                <DocumentRecord
                                  key={supplier.id}
                                  fieldName={fieldName}
                                  data={data}
                                  setData={setData}
                                  updateOpenedData={updateOpenedData}
                                  annotationField={annotationField}
                                  changedData={changedData}
                                  versionId={versionId}
                                  isEditing={isEditing}
                                  handleSidebarMouseOver={
                                    handleSidebarMouseOver
                                  }
                                  handleSidebarMouseLeave={
                                    handleSidebarMouseLeave
                                  }
                                  selectedVersion={latestVersion}
                                />
                              );
                            })}
                        </Box>

                        <Box className={classes.invoiceRecordBox}>
                          {customerData?.length > 0 && (
                            <Typography
                              variant="body2"
                              className={classes.invoiceRecordTitle}
                            >
                              Customer
                            </Typography>
                          )}
                          {customerData?.length > 0 &&
                            customerData?.map((customer) => {
                              const fieldName = customer?.short_desc;
                              const annotationField =
                                customer?.annotation_field;
                              return (
                                <DocumentRecord
                                  key={customer.id}
                                  fieldName={fieldName}
                                  data={data}
                                  setData={setData}
                                  updateOpenedData={updateOpenedData}
                                  annotationField={annotationField}
                                  changedData={changedData}
                                  versionId={versionId}
                                  isEditing={isEditing}
                                  handleSidebarMouseOver={
                                    handleSidebarMouseOver
                                  }
                                  handleSidebarMouseLeave={
                                    handleSidebarMouseLeave
                                  }
                                  selectedVersion={latestVersion}
                                />
                              );
                            })}
                        </Box>

                        <Box className={classes.invoiceRecordBox}>
                          {paymentData?.length > 0 && (
                            <Typography
                              variant="body2"
                              className={classes.invoiceRecordTitle}
                            >
                              Payment
                            </Typography>
                          )}
                          {paymentData?.length > 0 &&
                            paymentData?.map((payment) => {
                              const fieldName = payment?.short_desc;
                              const annotationField = payment?.annotation_field;
                              return (
                                <DocumentRecord
                                  key={payment.id}
                                  fieldName={fieldName}
                                  data={data}
                                  setData={setData}
                                  updateOpenedData={updateOpenedData}
                                  annotationField={annotationField}
                                  changedData={changedData}
                                  versionId={versionId}
                                  isEditing={isEditing}
                                  handleSidebarMouseOver={
                                    handleSidebarMouseOver
                                  }
                                  handleSidebarMouseLeave={
                                    handleSidebarMouseLeave
                                  }
                                  selectedVersion={latestVersion}
                                />
                              );
                            })}
                        </Box>

                        <Box className={classes.invoiceRecordBox}>
                          {paymentMethodData?.length > 0 && (
                            <Typography
                              variant="body2"
                              className={classes.invoiceRecordTitle}
                            >
                              Payment Method
                            </Typography>
                          )}
                          {paymentMethodData?.length > 0 &&
                            paymentMethodData?.map((paymentMethod) => {
                              const fieldName = paymentMethod?.short_desc;
                              const annotationField =
                                paymentMethod?.annotation_field;
                              return (
                                <DocumentRecord
                                  key={paymentMethod.id}
                                  fieldName={fieldName}
                                  data={data}
                                  setData={setData}
                                  updateOpenedData={updateOpenedData}
                                  annotationField={annotationField}
                                  changedData={changedData}
                                  versionId={versionId}
                                  isEditing={isEditing}
                                  handleSidebarMouseOver={
                                    handleSidebarMouseOver
                                  }
                                  handleSidebarMouseLeave={
                                    handleSidebarMouseLeave
                                  }
                                  selectedVersion={latestVersion}
                                />
                              );
                            })}
                        </Box>

                        <Box className={classes.invoiceRecordBox}>
                          {bankDetails?.length > 0 && (
                            <Typography
                              variant="body2"
                              className={classes.invoiceRecordTitle}
                            >
                              Bank Details
                            </Typography>
                          )}
                          {bankDetails?.length > 0 &&
                            bankDetails?.map((ele) => {
                              const fieldName = ele?.short_desc;
                              const annotationField = ele?.annotation_field;
                              return (
                                <DocumentRecord
                                  key={ele.id}
                                  fieldName={fieldName}
                                  data={data}
                                  setData={setData}
                                  updateOpenedData={updateOpenedData}
                                  annotationField={annotationField}
                                  changedData={changedData}
                                  versionId={versionId}
                                  isEditing={isEditing}
                                  handleSidebarMouseOver={
                                    handleSidebarMouseOver
                                  }
                                  handleSidebarMouseLeave={
                                    handleSidebarMouseLeave
                                  }
                                  selectedVersion={latestVersion}
                                />
                              );
                            })}
                        </Box>

                        <Box className={classes.invoiceRecordBox}>
                          {cardHolder?.length > 0 && (
                            <Typography
                              variant="body2"
                              className={classes.invoiceRecordTitle}
                            >
                              Card Holder
                            </Typography>
                          )}
                          {cardHolder?.length > 0 &&
                            cardHolder?.map((ele) => {
                              const fieldName = ele?.short_desc;
                              const annotationField = ele?.annotation_field;
                              return (
                                <DocumentRecord
                                  key={ele.id}
                                  fieldName={fieldName}
                                  data={data}
                                  setData={setData}
                                  updateOpenedData={updateOpenedData}
                                  annotationField={annotationField}
                                  changedData={changedData}
                                  versionId={versionId}
                                  isEditing={isEditing}
                                  handleSidebarMouseOver={
                                    handleSidebarMouseOver
                                  }
                                  handleSidebarMouseLeave={
                                    handleSidebarMouseLeave
                                  }
                                  selectedVersion={latestVersion}
                                />
                              );
                            })}
                        </Box>

                        <Box className={classes.invoiceRecordBox}>
                          {cardInfo?.length > 0 && (
                            <Typography
                              variant="body2"
                              className={classes.invoiceRecordTitle}
                            >
                              Card Info
                            </Typography>
                          )}
                          {cardInfo?.length > 0 &&
                            cardInfo?.map((ele) => {
                              const fieldName = ele?.short_desc;
                              const annotationField = ele?.annotation_field;
                              return (
                                <DocumentRecord
                                  key={ele.id}
                                  fieldName={fieldName}
                                  data={data}
                                  setData={setData}
                                  updateOpenedData={updateOpenedData}
                                  annotationField={annotationField}
                                  changedData={changedData}
                                  versionId={versionId}
                                  isEditing={isEditing}
                                  handleSidebarMouseOver={
                                    handleSidebarMouseOver
                                  }
                                  handleSidebarMouseLeave={
                                    handleSidebarMouseLeave
                                  }
                                  selectedVersion={latestVersion}
                                />
                              );
                            })}
                        </Box>

                        <Box className={classes.invoiceRecordBox}>
                          {accountHolderDetails?.length > 0 && (
                            <Typography
                              variant="body2"
                              className={classes.invoiceRecordTitle}
                            >
                              Account Holder Details
                            </Typography>
                          )}
                          {accountHolderDetails?.length > 0 &&
                            accountHolderDetails?.map((ele) => {
                              const fieldName = ele?.short_desc;
                              const annotationField = ele?.annotation_field;
                              return (
                                <DocumentRecord
                                  key={ele.id}
                                  fieldName={fieldName}
                                  data={data}
                                  setData={setData}
                                  updateOpenedData={updateOpenedData}
                                  annotationField={annotationField}
                                  changedData={changedData}
                                  versionId={versionId}
                                  isEditing={isEditing}
                                  handleSidebarMouseOver={
                                    handleSidebarMouseOver
                                  }
                                  handleSidebarMouseLeave={
                                    handleSidebarMouseLeave
                                  }
                                  selectedVersion={latestVersion}
                                />
                              );
                            })}
                        </Box>

                        <Box className={classes.invoiceRecordBox}>
                          {statementDetails?.length > 0 && (
                            <Typography
                              variant="body2"
                              className={classes.invoiceRecordTitle}
                            >
                              Statement Details
                            </Typography>
                          )}
                          {statementDetails?.length > 0 &&
                            statementDetails?.map((ele) => {
                              const fieldName = ele?.short_desc;
                              const annotationField = ele?.annotation_field;
                              return (
                                <DocumentRecord
                                  key={ele.id}
                                  fieldName={fieldName}
                                  data={data}
                                  setData={setData}
                                  updateOpenedData={updateOpenedData}
                                  annotationField={annotationField}
                                  changedData={changedData}
                                  versionId={versionId}
                                  isEditing={isEditing}
                                  handleSidebarMouseOver={
                                    handleSidebarMouseOver
                                  }
                                  handleSidebarMouseLeave={
                                    handleSidebarMouseLeave
                                  }
                                  selectedVersion={latestVersion}
                                />
                              );
                            })}
                        </Box>

                        <Box className={classes.invoiceRecordBox}>
                          {summary?.length > 0 && (
                            <Typography
                              variant="body2"
                              className={classes.invoiceRecordTitle}
                            >
                              Summary
                            </Typography>
                          )}
                          {summary?.length > 0 &&
                            summary?.map((ele) => {
                              const fieldName = ele?.short_desc;
                              const annotationField = ele?.annotation_field;
                              return (
                                <DocumentRecord
                                  key={ele.id}
                                  fieldName={fieldName}
                                  data={data}
                                  setData={setData}
                                  updateOpenedData={updateOpenedData}
                                  annotationField={annotationField}
                                  changedData={changedData}
                                  versionId={versionId}
                                  isEditing={isEditing}
                                  handleSidebarMouseOver={
                                    handleSidebarMouseOver
                                  }
                                  handleSidebarMouseLeave={
                                    handleSidebarMouseLeave
                                  }
                                  selectedVersion={latestVersion}
                                />
                              );
                            })}
                        </Box>

                        <Box className={classes.invoiceRecordBox}>
                          {bankCharges?.length > 0 && (
                            <Typography
                              variant="body2"
                              className={classes.invoiceRecordTitle}
                            >
                              Bank Charges
                            </Typography>
                          )}
                          {bankCharges?.length > 0 &&
                            bankCharges?.map((ele) => {
                              const fieldName = ele?.short_desc;
                              const annotationField = ele?.annotation_field;
                              return (
                                <DocumentRecord
                                  key={ele.id}
                                  fieldName={fieldName}
                                  data={data}
                                  setData={setData}
                                  updateOpenedData={updateOpenedData}
                                  annotationField={annotationField}
                                  changedData={changedData}
                                  versionId={versionId}
                                  isEditing={isEditing}
                                  handleSidebarMouseOver={
                                    handleSidebarMouseOver
                                  }
                                  handleSidebarMouseLeave={
                                    handleSidebarMouseLeave
                                  }
                                  selectedVersion={latestVersion}
                                />
                              );
                            })}
                        </Box>

                        <Box className={classes.invoiceRecordBox}>
                          {statement?.length > 0 && (
                            <Typography
                              variant="body2"
                              className={classes.invoiceRecordTitle}
                            >
                              Statement
                            </Typography>
                          )}
                          {statement?.length > 0 &&
                            statement?.map((ele) => {
                              const fieldName = ele?.short_desc;
                              const annotationField = ele?.annotation_field;
                              return (
                                <DocumentRecord
                                  key={ele.id}
                                  fieldName={fieldName}
                                  data={data}
                                  setData={setData}
                                  updateOpenedData={updateOpenedData}
                                  annotationField={annotationField}
                                  changedData={changedData}
                                  versionId={versionId}
                                  isEditing={isEditing}
                                  handleSidebarMouseOver={
                                    handleSidebarMouseOver
                                  }
                                  handleSidebarMouseLeave={
                                    handleSidebarMouseLeave
                                  }
                                  selectedVersion={latestVersion}
                                />
                              );
                            })}
                        </Box>

                        {/* <Box className={classes.invoiceRecordBox}>
                  {transactions?.length > 0 && (
                    <Typography
                      variant="body2"
                      className={classes.invoiceRecordTitle}
                    >
                      Transactions
                    </Typography>
                  )}
                  {transactions?.length > 0
                    && transactions?.map((ele) => {
                      const fieldName = ele?.short_desc;
                      const annotationField = ele?.annotation_field;
                      return (
                        <DocumentRecord
                          key={ele.id}
                          fieldName={fieldName}
                          data={data}
                          setData={setData}
                          updateOpenedData={updateOpenedData}
                          annotationField={annotationField}
                          changedData={changedData}
                          versionId={versionId}
                          isEditing={isEditing}
                          handleSidebarMouseOver={handleSidebarMouseOver}
                          handleSidebarMouseLeave={handleSidebarMouseLeave}
                          selectedVersion={latestVersion}
                        />
                      );
                    })}
                </Box> */}

                        {/* {Transactions?.map((productItem, index) => (
                      <Box
                        className={classes.invoiceRecordBox}
                        key={`${index + 1}`}
                      >
                        {transactionData?.length > 0 && (
                          <Typography
                            variant="body2"
                            className={classes.invoiceRecordTitle}
                          >
                            Transaction
                            {' '}
                            {index + 1}
                          </Typography>
                        )}
                        {transactionData?.length > 0
                      && transactionData.map((product) => {
                        const fieldName = product?.short_desc;
                        const annotationField = product?.annotation_field;
                        return (
                          <DocumentRecord
                            key={product.id}
                            fieldName={fieldName}
                            data={data}
                            setData={setData}
                            updateOpenedData={updateOpenedData}
                            annotationField={annotationField}
                            productNo={index + 1}
                            changedData={changedData}
                            versionId={versionId}
                            isEditing={isEditing}
                            handleSidebarMouseOver={handleSidebarMouseOver}
                            handleSidebarMouseLeave={handleSidebarMouseLeave}
                            productNumber={index + 1}
                            selectedVersion={latestVersion}
                          />
                        );
                      })}
                      </Box>
                    ))} */}

                        <Box className={classes.invoiceRecordBox}>
                          {GSTInfo?.length > 0 && (
                            <Typography
                              variant="body2"
                              className={classes.invoiceRecordTitle}
                            >
                              GST Info
                            </Typography>
                          )}
                          {GSTInfo?.length > 0 &&
                            GSTInfo?.map((ele) => {
                              const fieldName = ele?.short_desc;
                              const annotationField = ele?.annotation_field;
                              return (
                                <DocumentRecord
                                  key={ele.id}
                                  fieldName={fieldName}
                                  data={data}
                                  setData={setData}
                                  updateOpenedData={updateOpenedData}
                                  annotationField={annotationField}
                                  changedData={changedData}
                                  versionId={versionId}
                                  isEditing={isEditing}
                                  handleSidebarMouseOver={
                                    handleSidebarMouseOver
                                  }
                                  handleSidebarMouseLeave={
                                    handleSidebarMouseLeave
                                  }
                                  selectedVersion={latestVersion}
                                />
                              );
                            })}
                        </Box>

                        {/* {products?.map((productItem, index) => (
                      <Box
                        className={classes.invoiceRecordBox}
                        key={`${index + 1}`}
                      >
                        {productData?.length > 0 && (
                          <Typography
                            variant="body2"
                            className={classes.invoiceRecordTitle}
                          >
                            Product
                            {' '}
                            {index + 1}
                          </Typography>
                        )}
                        {productData?.length > 0
                      && productData.map((product) => {
                        const fieldName = product?.short_desc;
                        const annotationField = product?.annotation_field;
                        return (
                          <DocumentRecord
                            key={product.id}
                            fieldName={fieldName}
                            data={data}
                            setData={setData}
                            updateOpenedData={updateOpenedData}
                            annotationField={annotationField}
                            productNo={index + 1}
                            changedData={changedData}
                            versionId={versionId}
                            isEditing={isEditing}
                            handleSidebarMouseOver={handleSidebarMouseOver}
                            handleSidebarMouseLeave={handleSidebarMouseLeave}
                            productNumber={index + 1}
                            selectedVersion={latestVersion}
                          />
                        );
                      })}
                      </Box>
                    ))} */}
                      </Box>
                    </Box>
                  </TabPanel>
                  <TabPanel
                    value="2"
                    style={{
                      height: '100%',
                      padding: '0px',
                      paddingTop: '30px',
                    }}
                  >
                    <Box className={classes.invoiceGridInnerBox}>
                      <Box className={classes.transactinGrid}>
                        <AgGrid
                          className={classes.transactionGridSection}
                          isFilter
                          columnData={getColumnData()}
                          getRowData={getAllTransaction}
                          gridSettingData={gridSettingData}
                          gridKey="Transactions"
                          functionData={params?.id}
                          transactionData={getTransactionData()}
                          mapData={data}
                          updateOpenedData={updateOpenedData}
                          selectedVersion={latestVersion}
                          changedData={changedData}
                          versionId={versionId}
                          isEditing={isEditing}
                          setIsEdited={setIsEdited}
                          isEdited={isEdited}
                        />
                      </Box>
                    </Box>
                  </TabPanel>
                </TabContext>
              </Box>
              {checkedDataFields &&
                Object.keys(checkedDataFields).length !== 0 && (
                  <Box className={classes.invoiceGridBox}>
                    <Grid container>
                      <Grid item xs={12}>
                        <Box className={classes.confirmDocumentButtonContainer}>
                          <Button
                            className={classes.validateBtn}
                            component={buttonComponent}
                            to={confirmButtonUrl}
                            onClick={() =>
                              validateBtnOnClick(versionId, isEditing)
                            }
                          >
                            {getIconComponent(versionId, isEditing)}
                            {buttonText}
                          </Button>
                          <Box
                            className={classes.deleteButton}
                            aria-label="delete"
                            size="small"
                            onClick={ConfirmationDeletePopup}
                          >
                            <DeleteOutlineIcon />
                          </Box>
                          {exportDocumentOpen && (
                            <ConfirmDocument
                              CloseEditInfo={CloseExportDocument}
                              invoiceId={id}
                              annotationData={data}
                              mappedResult={mappedResult}
                              documentUrl={invoiceImg[[currentPageIndex]]}
                              exportDocumentOpen={exportDocumentOpen}
                              invoiceVersions={invoiceVersions}
                              getInvoiceVersion={getInvoiceVersion}
                              setIsLoading={setIsLoading}
                              setIsVersionAdded={setIsVersionAdded}
                              data={data}
                              changedData={changedData}
                              saveAndExitOpen={saveAndExitOpen}
                              setSaveAndExitOpen={setSaveAndExitOpen}
                              exportToJsonOpen={exportToJsonOpen}
                              exportToXmlOpen={exportToXmlOpen}
                              setExportToJsonOpen={setExportToJsonOpen}
                              setExportToXmlOpen={setExportToXmlOpen}
                              saveOpen={saveOpen}
                              setSaveOpen={setSaveOpen}
                              open={exportDocumentOpen}
                            />
                          )}
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                )}
              {checkedDataFields &&
                Object.keys(checkedDataFields).length === 0 && (
                  <Box style={{ marginTop: 'auto' }}>
                    <Typography variant="h5">
                      {ANNOTATION.INVOICE_ANNOTATION_MESSAGE.VALIDATION_MESSAGE}{' '}
                      <Link className="linkStyle" to="/settings">
                        Invoice Settings
                      </Link>
                    </Typography>
                  </Box>
                )}
            </Box>
          </ResizeGrid>
        </Box>
      )}
      {isConfirmationDialogOpen ? (
        <ConfirmDialog
          open={isConfirmationDialogOpen}
          onClose={handleCloseDialog}
          onConfirm={handleConfirmAction}
          askingMessage="Are You Sure You Want to Delete This Document"
        />
      ) : null}
    </Root>
  );
};

export default DocumentAnnotation;
